(() => {
  "use strict";

  // Define parameters to work
  const paramList = [
    "trkid",
    "ctx",
    "cka",
    "cko",
    "cks1",
    "cks2",
    "cks3",
    "cks4",
    "first",
    "first_name",
    "middle",
    "middle_name",
    "last",
    "last_name",
    "email",
    "postalcode",
    "fbclid",
    "gclid",
    "msclkid",
    "og1",
    "s1",
    "s2",
    "s3",
    "s4",
    "s5",
    "sub5",
    "subid",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "vertical",
    "state",
    "zip",
    "zip_1",
    "id",
    "reqid",
    "v",
  ];

  // Creates an array with params values:
  // ?parameter=value
  // [parameter: "value", ...]
  let params = {};
  const urlString = window.location.href;
  let url = new URL(urlString);
  paramList.forEach(function (key) {
    if (url.searchParams.get(key)) {
      params[key] = url.searchParams.get(key);
    }
  });

  if (0 < Object.keys(params).length) {
    // Checks if object is not empty.
    // Save object in local storage
    try {
      sessionStorage.setItem("cross-page-fields", JSON.stringify(params));
    } catch (error) {
      console.error("Failed to set sessionStorage:", error);
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    if ("cross-page-fields" in sessionStorage) {
      const sessionStorageParams = JSON.parse(
        sessionStorage.getItem("cross-page-fields"),
      ); // Retrieve data from local storage
      const processLink = function (href) {
        /* Concat parameters */
        let concat = [];
        for (let key in sessionStorageParams) {
          if ("string" === typeof sessionStorageParams[key]) {
            const paramPresent = href.includes(key);
            if (!paramPresent) {
              // Default concatenation.
              concat.push(key + "=" + sessionStorageParams[key]);
            }
          }
        }
        const output = concat.join("&");
        return output;
      };

      /* Concat parameters to links */
      let links = document.getElementsByTagName("a");

      //handle select
      // Get the <select> element by its ID
      let selectElement = document.getElementById(
        "interstitial-selector-select",
      );
      if (selectElement) {
        // Get all <option> elements within the <select>
        let options = selectElement.getElementsByTagName("option");
        for (let i = 0; i < options.length; i++) {
          let option = options[i];
          let url = option.value;

          // Check if the option has a non-empty URL value
          if ("" !== url) {
            // Create a URL object to validate the link
            try {
              let urlObj = new URL(url);
              if ("http:" !== urlObj.protocol && "https:" !== urlObj.protocol) {
                // Invalid protocol, skip this URL
                continue;
              }
              options[i].value =
                urlObj.origin + urlObj.pathname + "?" + processLink(url);
            } catch (error) {
              console.error(error);
              continue;
            }
          }
        }
      }

      // handle links
      for (let i = 0; i < links.length; i++) {
        let elem = links[i];
        let href = elem.href;

        if (!elem.href) {
          continue;
        }

        href = href.replace(/\s+/g, "");
        const classes = elem.className;

        if (
          classes.includes("SPNoConcat") ||
          href.includes("#") ||
          href.includes("unsubscribe") ||
          href.includes("california-privacy-request") ||
          href.includes("data-deletion-request")
        ) {
          // if has anchor or some links, continues to the next link.
          continue;
        }
        let output = processLink(href);

        if (0 < href.indexOf("?")) {
          href = href + "&";
        } else {
          href = href + "?";
        }

        /* Adds '&' beetween each `parameter=value` */
        href = href + output;
        elem.href = href;
      }
    }

    const appendTyParams = function () {
      const appendTyParamElement = document.querySelector(".appendTyParam");

      if (!appendTyParamElement) return;

      // Business logic.
      const handleIntersectionAppendTyParams = function (entries) {
        entries.map((entry) => {
          if (entry.isIntersecting) {
            const tyParamList = [
              "ctx",
              "utm_campaign",
              "utm_content",
              "utm_medium",
              "utm_source",
              "utm_term",
              "email",
              "first_name",
              "last_name",
              "v",
            ];

            let urlHref = window.location.href;
            let url = new URL(urlHref);

            let params = {};

            // Get key and value from the parameters inside the URL.
            tyParamList.forEach(function (key) {
              if (url.searchParams.get(key)) {
                params[key] = url.searchParams.get(key);
              }
            });

            if (0 !== Object.keys(params).length) {
              let links = document.querySelectorAll(".appendTyParam");
              for (let i = 0; i < links.length; i++) {
                // Get the complete link.
                let href = links[i].href;

                // Get the link without the parameters.
                let cleanHref = href.split("?")[0];

                let link = new URL(href);
                let linkParams = new URLSearchParams(link.searchParams);

                // Set the parameters in the array from the URL in the link.
                tyParamList.forEach(function (key) {
                  if (params[key]) {
                    linkParams.set(key, params[key]);
                  }
                });

                let newParams = linkParams.toString();

                // Form the new link.
                links[i].setAttribute("href", cleanHref + "?" + newParams);
              }
            }
            appendTyParamsObserver.disconnect();
          }
        });
      };

      const options = {
        threshold: 0,
      };

      const appendTyParamsObserver = new IntersectionObserver(
        handleIntersectionAppendTyParams,
        options,
      );

      appendTyParamsObserver.observe(appendTyParamElement);
    };

    if ("undefined" !== typeof window.IntersectionObserver) {
      try {
        appendTyParams();
      } catch (error) {
        console.error(error);
      }
    }
  });
})();
